// extracted by mini-css-extract-plugin
export default {"orders":"AssignedOrders_orders__YbTSc","vehicles":"AssignedOrders_vehicles__SjBZh","vehicle":"AssignedOrders_vehicle__q7TPA","noOrders":"AssignedOrders_noOrders__B7KeG"};